import { Link } from 'react-router-dom'
import { Table, type Column } from 'grabbitbot-legacy-ui'
import type { Strategy } from '../../api/tradingTypes'
import { formatDateTime } from './tradingConstants'

/**
 * The strategy list shared by legacy `V3StrategyListSpotComponent` ("my
 * strategies") and `V3StrategySearchSpotComponent` (marketplace) — the two
 * templates were byte-identical card lists. Rendered on the fleet-standard
 * sortable Table instead of cards; same fields: public name (link to the
 * sheet), description, started at, trader, Details. The legacy Edit
 * link (owner only) pointed at a non-functional stub and was removed. The commented-out Subscribe/Unsubscribe and
 * statistics fields of the legacy cards were dead and are not rendered.
 */
export function StrategyTable({ strategies }: { strategies: Strategy[] }) {
  const columns: Column<Strategy>[] = [
    {
      key: 'realPublicName',
      label: 'Strategy',
      align: 'left',
      format: (_v, s) => <Link to={`/strategy/spot/${s.id}`}>{s.realPublicName}</Link>,
    },
    { key: 'description', label: 'Description', align: 'left' },
    {
      key: 'createdAt',
      label: 'Started at',
      align: 'left',
      sortValue: (s) => s.createdAt ?? '',
      format: (_v, s) => formatDateTime(s.createdAt),
    },
    {
      key: 'traderId',
      label: 'Trader',
      align: 'left',
      format: (_v, s) => <Link to={`/trader/${s.traderId}`}>{s.traderId}</Link>,
    },
    {
      key: 'id',
      label: '',
      sortable: false,
      format: (_v, s) => (
        <span className="portal-inline-actions">
          <Link to={`/strategy/spot/${s.id}`} className="portal-button-link">
            Details
          </Link>
        </span>
      ),
    },
  ]
  return (
    <div className="portal-table-scroll">
      <Table columns={columns} rows={strategies} rowKey={(s) => s.id} initialSort={null} />
    </div>
  )
}
